export function resourceProtection() {
  const buttons = document.querySelectorAll("[data-resource-url]");
  if (!buttons.length) return;

  const STORAGE_KEY = "resource_subscribed";
  const popupWrap = document.querySelector("[data-resource-popup]");
  const popupTrigger = popupWrap?.querySelector("[data-sgd-popup-trigger]");
  const popupId = popupTrigger?.dataset.sgdPopupTrigger;
  const popupEl = popupId
    ? document.querySelector(`#sgd-popup-${popupId}`)
    : null;
  // Selectors depend on GF field cssClasses staying "nexus-resource-url-field"
  // and "nexus-resource-slug-field". If an admin removes them, the stash below
  // becomes a no-op: the confirmation renders an empty Download href and the
  // Mailchimp feed Tags merge tag for slug stays empty.
  const RESOURCE_URL_SELECTOR = ".nexus-resource-url-field input";
  const RESOURCE_SLUG_SELECTOR = ".nexus-resource-slug-field input";

  function stashHiddenField(selector, value, fieldName) {
    const input = popupEl?.querySelector(selector);
    if (input) {
      input.value = value ?? "";
    } else {
      console.warn(
        `[resource-protection] hidden ${fieldName} field not found — feed value will be empty`
      );
    }
  }

  function isSubscribed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  }

  // Swap "Subscribe to download" → "Download" on protected buttons once the
  // user has subscribed. Runs on init (handles page reloads) and on the
  // "resource:subscribed" event (handles same-page subscribe without reload).
  function updateLabels() {
    if (!isSubscribed()) return;
    buttons.forEach((button) => {
      const newLabel = button.dataset.resourceSubscribedLabel;
      if (!newLabel) return;
      const labelEl = button.querySelector(".link-arrow");
      if (labelEl) labelEl.textContent = newLabel;
    });
  }

  updateLabels();
  window.addEventListener("resource:subscribed", updateLabels);

  // Subscription bypass flag is set by the [resource_subscribed] shortcode,
  // which renders an inline <script> inside the GF confirmation message.
  // jQuery (used by GF AJAX submit) executes inline scripts when injecting
  // HTML, so the flag is set the moment confirmation renders. The shortcode
  // also dispatches a "resource:subscribed" event so updateLabels() can swap
  // labels in real time without waiting for a page reload.

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const url = button.dataset.resourceUrl;
      const isProtected = button.dataset.resourceIsProtected === "true";

      if (!isProtected || isSubscribed()) {
        window.open(url, "_blank");
        return;
      }

      // Protected and not subscribed: stash URL + slug into hidden form fields
      // so GF confirmation can render the URL via {Resource URL:6} merge tag
      // and the Mailchimp feed Tags can use {Resource Slug:7} for per-resource
      // tagging. Query at click time: GF replaces the form HTML on successful
      // submit, so any reference captured at init becomes a detached node
      // after the first successful subscription.
      stashHiddenField(RESOURCE_URL_SELECTOR, url, "URL");
      stashHiddenField(
        RESOURCE_SLUG_SELECTOR,
        button.dataset.resourceSlug,
        "slug"
      );

      popupTrigger?.click();
    });
  });
}
